import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "body2-text text-black" };
const _hoisted_2 = { class: "body2-text text-black" };
const _hoisted_3 = { class: "body2-text text-black" };
const _hoisted_4 = { class: "body2-text text-black" };
const _hoisted_5 = { class: "body2-text text-black" };
const _hoisted_6 = { class: "body2-text text-black" };
const _hoisted_7 = { class: "body2-text text-black" };
const _hoisted_8 = { class: "body2-text text-black" };
const _hoisted_9 = { class: "body2-text text-black" };
const _hoisted_10 = { class: "body2-text text-black" };
const _hoisted_11 = { class: "body2-text text-black" };
const _hoisted_12 = { class: "body2-text text-black" };
const _hoisted_13 = { class: "body2-text text-black" };
const _hoisted_14 = { class: "body2-text text-black" };
const _hoisted_15 = { class: "body2-text text-black" };
const _hoisted_16 = { class: "body2-text text-black" };
const _hoisted_17 = {
    key: 0,
    class: "body2-text text-black"
};
const _hoisted_18 = { class: "body2-text text-black" };
const _hoisted_19 = { class: "body2-text text-black" };
const _hoisted_20 = { class: "body2-text text-black" };
const _hoisted_21 = { class: "body2-text text-black" };
const _hoisted_22 = { class: "body2-text text-black" };
const _hoisted_23 = { class: "body2-text text-black" };
const _hoisted_24 = { class: "body2-text text-black" };
const _hoisted_25 = { class: "body2-text text-black" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InputRow = _resolveComponent("InputRow");
    return (_openBlock(), _createElementBlock("div", null, [
        _createCommentVNode(" 상점명 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}store_name`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.detail.validatedStoreName) + " / " + _toDisplayString(_ctx.detail.validatedStoreCode), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 소속 허브 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_code`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.detail.validatedHubName) + " / " + _toDisplayString(_ctx.detail.validatedHubCode), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 상점 ID "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}master_id`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.detail.validatedMasterId), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 주소 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}address`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.detail.formattedFullAddress), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 단말기 출발지 메모 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}address_memo`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.detail.validateAddressMemo), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 관리자 메모 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}memo`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.detail.validatedMemo), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 상점 전화번호 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}phone`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.detail.formattedPhone), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 상점 안심번호 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}safe_phone`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.detail.formattedSafePhone), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 상점 팩스번호 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}fax`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.detail.formattedFax), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 상점 상태 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}use_yn`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.detail.formattedUseYn), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 카드 VAN 사 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}main_van_type_code`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.detail.vanCodeName), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 터미널 ID "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}main_van_terminal_id`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.detail.validatedMainVanTerminalId), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 휴무일 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}rest_day`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.detail.validatedRestDays), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 배달 운영시간 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}working_time`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.workingTime), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 예치금 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}deposit_baromoney`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.detail.formattedDepositBaromoney), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 출금계좌 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}withdrawal_bank_account`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.validatedWithdrawalBankOwner), 1 /* TEXT */),
                (_ctx.isWithdrawalAccountExist)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, " / " + _toDisplayString(_ctx.bankName) + " " + _toDisplayString(_ctx.detail.formattedWithdrawalBankAccount), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 충전 가상계좌 :: 기존 내용 "),
        _createCommentVNode(" <InputRow\n      :label=\"$t(`${lc}virtual_bank_account`)\"\n      wide-title\n    >\n      <span class=\"body2-text text-black\">\n        {{ virtualAccount }}\n      </span>\n    </InputRow> "),
        _createCommentVNode(" 출금 가상 계좌 "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.virtualBankList, ({ name, account }, key) => {
            return (_openBlock(), _createBlock(_component_InputRow, {
                key: key,
                label: _ctx.$t(`${_ctx.lc}virtual_bank_account_multiple`, { key: key + 1 }),
                "wide-title": ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(name) + " " + _toDisplayString(account), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]));
        }), 128 /* KEYED_FRAGMENT */)),
        _createCommentVNode(" 사업자등록번호 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}business_number`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createCommentVNode(" P2\n        <Chip\n        :text=\"$t(businessNumber.text)\"\n        :color=\"businessNumber.color\"\n        :text-color=\"businessNumber.textColor\"\n      >\n      </Chip> "),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.detail.validatedBusinessNumber), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 상호명 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}business_name`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.detail.validatedBusinessName), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 대표자명 | 대표자 생년월일 or 법인 등록번호 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}ceo_name`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.detail.validatedCeoName) + " / " + _toDisplayString(_ctx.detail.ceoResidentRegistrationNumber), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 대표자 휴대폰 번호 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}ceo_phone`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.detail.formattedCeoPhone), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 대표자 이메일 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}ceo_email`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.detail.validatedCeoEmail), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 업태 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}business_condition`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.detail.validatedBusinessCondition), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 종목 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}business_type`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.detail.validatedBusinessType), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"])
    ]));
}
